import { errorHandler, notifyMessageCreator } from 'Modules'
import { call, put, takeEvery, select } from 'typed-redux-saga'
import { routerActions } from 'connected-react-router'
import { ResponseCatalog, RequestParams } from 'Models'
import { AttemptModel, attemptApi, AttemptNS, attemptSlice } from 'Pages/survey'
import { authSelector } from 'Pages/auth'
import { FrontUrls } from 'Constants/FrontUrls'

function* getAll(action: AttemptNS.GetAll) {
	try {
		const { survey_id, user_id } = action.payload
		const auth = yield* select(authSelector.getAuthDataSelector)
		const res = yield* call(
			attemptApi.getAll,
			survey_id,
			new RequestParams(1, 1, null, { user_id: user_id || auth.id })
		)
		if (res?.entries.length) {
			yield* put(attemptSlice.actions.getOne({ id: res.entries[0].id }))
		} else {
			yield* put(attemptSlice.actions.createOne({ survey_id }))
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getOne(action: AttemptNS.GetOne) {
	try {
		const { id } = action.payload
		const res = yield* call(attemptApi.getOne, id)
		if (res.status.status_slug === 'completed') {
			yield* put(routerActions.push(FrontUrls.survey.index))
		} else {
			const current = new ResponseCatalog<AttemptModel>()
			current.entries = [res]
			yield* put(attemptSlice.actions.setAll(current))
		}
	} catch (error) {
		if (error.status === 404) {
			const { id } = action.payload
			const res = yield* call(attemptApi.createOne, id)
			const current = new ResponseCatalog<AttemptModel>()
			current.entries = [res]
			yield* put(attemptSlice.actions.setAll(current))
		}
		yield* call(errorHandler, error)
	}
}

function* createOne(action: AttemptNS.CreateOne) {
	try {
		const { callback, survey_id } = action.payload
		const res = yield* call(attemptApi.createOne, survey_id)
		const current = new ResponseCatalog<AttemptModel>()
		current.entries = [res]
		yield* put(attemptSlice.actions.setAll(current))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
		yield* put(routerActions.push(FrontUrls.survey.index))
	}
}

function* updateOne(action: AttemptNS.UpdateOne) {
	try {
		const { callback, attempt_id } = action.payload
		yield* call(attemptApi.updateOne, attempt_id, { status: 'completed' })
		yield* call(notifyMessageCreator, 'common.survey.completed')
		callback?.()
		yield* put(routerActions.push(FrontUrls.survey.survey_complete))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOne(action: AttemptNS.DeleteOne) {
	try {
		const { callback, id } = action.payload
		yield* call(attemptApi.deleteOne, id)
		yield* call(notifyMessageCreator, 'common.option_delete.success')
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const attemptSaga = function* saga() {
	yield* takeEvery(attemptSlice.actions.getAll.type, getAll)
	yield* takeEvery(attemptSlice.actions.getOne.type, getOne)
	yield* takeEvery(attemptSlice.actions.createOne.type, createOne)
	yield* takeEvery(attemptSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(attemptSlice.actions.deleteOne.type, deleteOne)
}
